import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, EMPTY, tap } from 'rxjs';
import { IPostModel } from '../../../../models/post.model';
import { PostService } from '../../../../services/api/post/post.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-share-post-popup',
    standalone: false,
    templateUrl: './share-post-popup.component.html',
    styleUrl: './share-post-popup.component.scss',
})
export class SharePostPopupComponent extends BasePopupComponent {
    protected postLink = signal<string>('');
    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IPostModel,
        @Inject(PLATFORM_ID) private platformId: object,
        protected override dialogRef: MatDialogRef<SharePostPopupComponent>,
        private dialog: MatDialog,
        private matSnackBar: MatSnackBar,
        private postService: PostService,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.generatePostLink();
    }

    protected copyLink(): void {
        if (!isPlatformBrowser(this.platformId) || !this.postLink()) {
            return;
        }

        if (navigator && navigator.clipboard) {
            navigator.clipboard
                .writeText(this.postLink())
                .then(() => {
                    this.matSnackBar.open('Copied to clipboard.', '', { duration: 2000 });
                })
                .catch(() => {
                    this.matSnackBar.open('Failed to copy link.', '', { duration: 2000 });
                });
        } else {
            const tempInput = document.createElement('input');
            tempInput.value = this.postLink();
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            this.matSnackBar.open('Copied to clipboard.', '', { duration: 2000 });
        }
    }

    private generatePostLink(): void {
        this.postService
            .generateSharePostLink(this.data.id)
            .pipe(
                tap((response) => {
                    this.postLink.set(response.url);
                }),
                catchError((error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                    console.error('Error generating shareable post link:', error);
                    return EMPTY;
                }),
            )
            .subscribe();
    }
}
